import { axiosInstance } from '@/http-common'

export function resetTachoJob(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/api/v1/tacho/reset/${ id }`)
            .then(response => {
                resolve(response)
            })
            .catch(response => {
                reject(response)
            })
    })
}